import React, { useEffect, useState } from 'react';
import {ReactComponent as NotFinishedSvg} from '../../assets/cross.svg';
// import NotFinishedSvg from '../../assets/cross.svg';
import {ReactComponent as InProccesSvg} from '../../assets/walking.svg';
// import InProccesSvg from '../../assets/walking.svg';
import {ReactComponent as FinishedSvg} from '../../assets/check-mark.svg';
// import FinishedSvg from '../../assets/check-mark.svg';
import {
    assignRoute,
    editActiveRoute,
    revokeRoute,
    setRouteLocks,
} from '../../redux/advertSlice';
import { Map, Polygon, YMaps } from 'react-yandex-maps';
import { Button } from '../../components/Button';
import { PopupList } from '../../components/PopupList';
import { useDispatch, useSelector } from 'react-redux';
import { Popup } from '../../components/Popup';
import { Input } from '../../components/Input';
import { CLIENT_NOTS, getClientNotify } from '../../redux/notifySlice';
import { getLocalUTCDate, getStorageData, validateAssignRoute } from '../../helpers';
import { Link, useSearchParams } from 'react-router-dom';
import { Select } from '../../components/Select';
import {
    ADVERT_CITY_STORAGE_NAME,
    createHandlerWithStorage,
    ADVERT_FLYER_STORAGE_NAME,
    ASSIGN_ROUTE_BET_NAME,
} from '../../helpers/localStorage';
import { WrapWindow } from '../../components/WrapWindow';
import { CreateFinishRoutePopup } from './CreateFinishRoutePopup';
import { advertAPI } from '../../api';

const MAP_API_KEY = '';

const PromRoute = ({
    data,
    flyerTypes,
    setMapCenter,
    setRouteInfoId,
    routeInfoId,
    flyers,
}) => {
    
    const { coordinates, status, markCard, city } = data;
    const getColorByStatus = () => (!status ? '#1e98ff' : status > 0 ? '#1bad03' : '#ed4543');

    const handlePolygonClick = (evt) => {
        const coords = evt.get('coords');
        setMapCenter(coords);
        setRouteInfoId(data.id);
    };

    const closeInfoBox = () => {
        setRouteInfoId(null);
    };
    const isSelected = routeInfoId === data.id;
    const color = getColorByStatus();
    return (
        <>
            <Polygon
                geometry={[coordinates]}
                properties={{
                    hintContent: 'polygon',
                }}
                options={{
                    fillColor: isSelected ? `${color}AA` : markCard ? '#97a100AA' : '#00FF0000',
                    strokeColor: color,
                    opacity: 0.9,
                    strokeWidth: 4,
                    strokeStyle: 'solid',
                }}
                instanceRef={(ref) => {
                    if (ref) {
                        ref.events.add('click', handlePolygonClick);
                    }
                }}
            />
            {isSelected && (
                <RouteBlock
                    flyers={flyers}
                    flyerTypes={flyerTypes}
                    closeFn={closeInfoBox}
                    statusColor={color}
                    data={data}
                    city={city._id}
                />
            )}
        </>
    );
};

const AssignPromoter = ({
    routeLocks,
    mailboxCount,
    assignFn,
    closeFn,
    city
}) => {
    const proms = useSelector((state) => state.advert.promoters);
    const promoters = proms.filter((p) => !p.deleted && p.city._id === city);
    const [popupIndex, setPopupIndex] = useState(0);
    const [prom, selectProm] = useState(null);
    const selectPromHandler = (id) => {
        if (prom === id) {
            selectProm(null);
            return;
        }
        selectProm(id);
    };

    const [isBtnBlocked, setBtnBlocked] = useState(false);

    const flyerTypes = useSelector((state) => state.settings.flyerTypes);
    const [flyers, selectFlyers] = useState([]);
    const [givenFlyersCount, setGivenFlyersCount] = useState([]);
    const [hasCard, setHasCard] = useState(false);
    const selectFlyerHandler = (id) => {
        const name = flyerTypes.find((ft) => ft._id === id)?.name;
        if (flyers.some((f) => f === id)) {
            selectFlyers((prev) => prev.filter((f) => f !== id));
            setGivenFlyersCount((prev) => prev.filter((ft) => ft._id !== id));
            return;
        }
        selectFlyers((prev) => [...prev, id]);
        setGivenFlyersCount((prev) => [...prev, { _id: id, name, count: mailboxCount }]);
    };

    const selectedGivenFlyerCounts = givenFlyersCount
        .filter((f) => flyers.some((f2) => f2 === f._id))
        .map(({ name, ...rest }) => rest);

    const thisProm = promoters.find((p) => p._id === prom);
    const nextPopupHandler = () => {
        setPopupIndex(1);
    };

    const promElements = promoters.map((p) => (
        <div
            key={p._id}
            className={`popup-promoter-item ${prom === p._id ? 'selected dark-theme-bg1' : ''}`}
            onClick={() => selectPromHandler(p._id)}>
            <div>
                {p.fullname}
                {!!p.currentRoute._id && <sub>Занят</sub>}
            </div>
            <div>{p.isFullReport ? 'Полный отчет' : 'Фотоотчет'}</div>
            <div>Ставка: {p.bet}</div>
        </div>
    ));
    const createSearchFn = (_, val) => (el) =>
        el.props.children[0].props.children[0].toLowerCase().includes(val.toLowerCase());

    const PopupBody = () => {
        const [bet, setBet] = useState(localStorage.getItem(ASSIGN_ROUTE_BET_NAME) || thisProm.bet);
        const setBetHandler = createHandlerWithStorage(setBet, ASSIGN_ROUTE_BET_NAME);

        const [givenFlyers, setGivenFlyers] = useState(givenFlyersCount);

        const setGivenFlyersHandler = (count, _id) => {
            const name = flyerTypes.find((ft) => ft._id === _id)?.name;
            setGivenFlyers((prev) => prev.map((f) => (f._id !== _id ? f : { _id, count, name })));
        };
        return (
            <div className="route-settings-popup">
                <div className="route-settings-popup__item">
                    <p>Выберите листовки на данный маршрут</p>
                    <div className="button-list">
                        {flyerTypes.map((f) => (
                            <Button
                                key={f._id}
                                disabled={routeLocks.some((l) => l.flyer === f._id)}
                                classNames={`${flyers.some((f1) => f1 === f._id) ? 'active' : ''}`}
                                text={`${f.name}${f.isOwn ? ' (наша)' : ''}`}
                                onClick={() => selectFlyerHandler(f._id)}
                            />
                        ))}
                    </div>
                </div>
                <div className="route-settings-popup__item">
                    <Input
                        type="number"
                        min={0.01}
                        step={0.01}
                        label="Ставка"
                        flex="row"
                        value={bet}
                        changeHandler={(e) => setBetHandler(e.target.value)}
                    />
                    <span>руб за ящик</span>
                </div>
                <div className="route-settings-popup__item" style={{margin: '0 auto'}}>
                    <input id='withCard' type="checkbox" checked={hasCard} onChange={() => setHasCard(prev => !prev)}/>
                    <label htmlFor='withCard' style={{marginLeft: '6px', cursor: 'pointer'}}>Визитки на маршруте</label>
    
                </div>
                <div className="route-settings-popup__item">
                    <p>Укажите количество выданного материала</p>
                    {givenFlyers.map((ft) => (
                        <div key={ft._id}>
                            <span>{ft.name}</span>
                            <Input
                                onBlur={() => setGivenFlyersCount(givenFlyers)}
                                type="number"
                                min={0}
                                value={givenFlyers.find((f) => f._id === ft._id)?.count}
                                changeHandler={(e) =>
                                    setGivenFlyersHandler(+e.target.value, ft._id)
                                }
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const assignRouteHandler = () => {
        setBtnBlocked(true);
        const bet = +localStorage.getItem(ASSIGN_ROUTE_BET_NAME) || thisProm.bet;
        assignFn(
            () => setBtnBlocked(false),
            prom,
            bet,
            selectedGivenFlyerCounts,
            hasCard
        );
    };

    return !popupIndex ? (
        <PopupList
            button={<Button disabled={!prom} text="Далее" onClick={nextPopupHandler} />}
            title="Выберите промоутера"
            search={{
                createSearch: createSearchFn,
            }}
            closeFn={closeFn}
            children={promElements}
        />
    ) : (
        <Popup
            button={
                <>
                    <Button text="Назад" onClick={() => setPopupIndex(0)} />
                    <Button disabled={isBtnBlocked} text="Назначить" onClick={assignRouteHandler} />
                </>
            }
            title="Укажите условия маршрута"
            closeFn={closeFn}
            children={<PopupBody />}
        />
    );
};

const RouteBlock = ({
    data,
    flyerTypes,
    flyers,
    statusColor,
    closeFn,
    city
}) => {
    const dispatch = useDispatch();
    const {
        promoter,
        id,
        porchCount,
        status,
        mailboxCount,
        details: { started, locks },
    } = data;
    const getStatusName = () =>
        !status ? `${started ? 'В работе' : 'Назначен'}` : status > 0 ? 'Выполнен' : 'Не выполнен';
    const [isPopup, setPopup] = useState(false);
    const [isFinishRoutePopup, setFinishRoutePopup] = useState(false);
    const [isLockingPopup, setLockingPopup] = useState({ flag: false, isUnlock: false });
    const [isEditPopup, setEditPopup] = useState(false);

    const [isBtnBlocked, setBtnBlocked] = useState(false);

    const hasLocks = !!locks.length;
    const lockItems = locks.map(l => ({...l, flyer: flyers.find(f => f._id === l.flyer)?.name}));

    const [routeHistory, setRouteHistory] = useState(null);
    const [isHistoryDetailsOpen, toggleHistoryDetails] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const toggleHistoryDetailsHandler = async () => {
        toggleHistoryDetails(!isHistoryDetailsOpen);
        if (routeHistory) return;
        try {
            setIsLoading(true);
            setError(null);
            
            // Здесь делаем асинхронный запрос
            const result = await advertAPI.fetchRouteHistory(data._id);
            if (result.routeHistory) {
                setRouteHistory(result.routeHistory);
            } else {
                setError('Ошибка при загрузке истории')
            }
        } catch (err) {
            setError('Ошибка при загрузке истории');
            console.error('Ошибка загрузки истории:', err);
        } finally {
            setIsLoading(false);
        }
    }

    const assignPromoterHandler = (
        enableBtn,
        promoterId,
        bet,
        flyers,
        withCard,
    ) => {
        const assignData = {
            promoterId,
            routeId: data._id,
            bet,
            flyers,
            withCard
        };
        const validateResult = validateAssignRoute(assignData);
        if (!validateResult.isOkay) {
            dispatch(
                getClientNotify({
                    data: validateResult,
                    action: CLIENT_NOTS.EMPTY_FIELD,
                }),
            );
            return;
        }
        localStorage.removeItem(ASSIGN_ROUTE_BET_NAME);
        dispatch(assignRoute({ assignData, resetFunc: () => setPopup(false), enableBtn }));
    };
    const revokeRouteHandler = () => {
        if (
            window.confirm(
                'Вы собираетесь отозвать маршрут. Весь прогресс промоутера, включая отправленные фотографии и видео, обнулятся. Подтвердите действие',
            )
        ) {
            setBtnBlocked(true);
            dispatch(revokeRoute({ routeId: data._id, enableBtn: () => setBtnBlocked(false) }));
        }
    };

    const LockingRoutePopup = ({ isUnlock }) => {
        const newLockTime = Date.now() + 1000 * 3600 * 24 * 21;
        const getStrTime = (stamp) =>
            new Date(stamp - (1000 * 3600 * new Date().getTimezoneOffset()) / 60)
                .toISOString()
                .split('.')[0];
        const relevantFlyers = flyers
            .filter((f) =>
                isUnlock
                    ? locks.some((l) => l.flyer === f._id)
                    : !locks.some((l) => l.flyer === f._id),
            )
            .map((f) => ({
                ...f,
                until: locks.find((l) => l.flyer === f._id)?.until || newLockTime,
            }));

        const [lockState, setLockState] = useState(
            relevantFlyers.map((l) => ({
                _id: l._id,
                until: l.until,
                name: l.name,
                included: false,
            })),
        );
        const selectFlyerHandler = (id) => {
            setLockState((prev) =>
                prev.map((f) => (f._id !== id ? f : { ...f, included: !f.included })),
            );
        };
        const setUntilHandler = (until) => {
            setLockState((prev) => prev.map((l) => ({ ...l, until })));
        };
        const resetFn = () => setLockingPopup({ flag: false, isUnlock: false });
        const saveLocksHandler = () => {
            if (!lockState.length) return;
            const body = {
                routeId: data._id,
                locks: lockState.filter((ls) => ls.included).map((ls) => ls._id),
                until: lockState[0].until,
                isUnlock,
            };
            dispatch(setRouteLocks({ body, resetFn }));
        };
        return (
            <Popup
                closeFn={resetFn}
                title={`${isUnlock ? 'Раз' : 'За'}блокировать маршрут`}
                button={<Button text="Сохранить" onClick={saveLocksHandler} />}>
                <div className="locking-route-popup-body">
                    <p>
                        Укажите виды листовок, для которых вы хотите {isUnlock ? 'раз' : 'за'}
                        блокировать маршрут:
                    </p>
                    {lockState.map((lf) => (
                        <div key={lf._id}>
                            <Button
                                text={lf.name}
                                classNames={lf.included ? 'active' : ''}
                                onClick={() => selectFlyerHandler(lf._id)}
                            />
                            <span>Заблокирова{isUnlock ? 'н' : 'ть'} до</span>
                            <Input
                                type="datetime-local"
                                disabled={isUnlock || !lf.included}
                                changeHandler={(e) => setUntilHandler(+new Date(e.target.value))}
                                value={getStrTime(lf.until)}
                            />
                        </div>
                    ))}
                </div>
            </Popup>
        );
    };

    const EditRoutePopup = () => {
        const proms = useSelector((state) => state.advert.promoters);
        const thisPromoter = proms.find((p) => p._id === data.promoter?._id);
        const thisRoute = [...thisPromoter.routeQueue, thisPromoter.currentRoute].find(
            (cr) => cr._id === data._id,
        );

        const [bet, setBet] = useState(
            localStorage.getItem(ASSIGN_ROUTE_BET_NAME) || thisRoute.bet,
        );
        const setBetHandler = createHandlerWithStorage(setBet, ASSIGN_ROUTE_BET_NAME);

        const [selectedFlyers, selectFlyers] = useState(thisRoute.flyers.map((f) => f._id));

        const [givenFlyersCount, setGivenFlyersCount] = useState(
            thisRoute.givenFlyersCount.map((gf) => ({
                _id: gf.flyer._id,
                name: gf.flyer.name,
                count: gf.count,
            })),
        );
        const [givenFlyers, setGivenFlyers] = useState(givenFlyersCount);

        const [hasCard, setHasCard] = useState(thisRoute.withCard);

        const setGivenFlyersHandler = (count, _id) => {
            const name = flyers.find((ft) => ft._id === _id)?.name;
            setGivenFlyers((prev) => prev.map((f) => (f._id !== _id ? f : { _id, count, name })));
        };
        const selectFlyerHandler = (id) => {
            const name = flyers.find((ft) => ft._id === id)?.name;
            if (selectedFlyers.some((f) => f === id)) {
                selectFlyers((prev) => prev.filter((f) => f !== id));
                setGivenFlyersCount((prev) => prev.filter((ft) => ft._id !== id));
                return;
            }
            selectFlyers((prev) => [...prev, id]);
            setGivenFlyersCount((prev) => [...prev, { _id: id, name, count: mailboxCount }]);
        };

        useEffect(() => {
            setGivenFlyers(givenFlyersCount);
        }, [givenFlyersCount]);

        const editRouteHandler = () => {
            const body = {
                bet: +bet,
                flyers: givenFlyers,
                promoterId: thisPromoter._id,
                routeId: data._id,
                withCard: hasCard
            };
            localStorage.removeItem(ASSIGN_ROUTE_BET_NAME);
            dispatch(editActiveRoute({ editData: body, resetFunc: () => setEditPopup(false) }));
        };

        const closeFnHandler = () => {
            localStorage.removeItem(ASSIGN_ROUTE_BET_NAME);
            setEditPopup(false);
        }

        return (
            <Popup
                closeFn={closeFnHandler}
                title="Редактирование маршрута"
                button={<Button text="Сохранить" onClick={editRouteHandler} />}>
                <div className="route-settings-popup">
                    <div className="route-settings-popup__item">
                        <p>Выберите листовки на данный маршрут</p>
                        <div className="button-list">
                            {flyers.map((f) => (
                                <Button
                                    key={f._id}
                                    disabled={locks.some((l) => l.flyer === f._id)}
                                    classNames={`${
                                        selectedFlyers.some((f1) => f1 === f._id) ? 'active' : ''
                                    }`}
                                    text={`${f.name}${f.isOwn ? ' (наша)' : ''}`}
                                    onClick={() => selectFlyerHandler(f._id)}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="route-settings-popup__item">
                        <Input
                            type="number"
                            min={0.01}
                            step={0.01}
                            label="Ставка"
                            flex="row"
                            value={bet}
                            changeHandler={(e) => setBetHandler(e.target.value)}
                        />
                        <span>руб за ящик</span>
                    </div>
                    <div className="route-settings-popup__item" style={{margin: '0 auto'}}>
                        <input id='withCard' type="checkbox" checked={hasCard} onChange={() => setHasCard(prev => !prev)}/>
                        <label htmlFor='withCard' style={{marginLeft: '6px', cursor: 'pointer'}}>Визитки на маршруте</label>
                    </div>
                    <div className="route-settings-popup__item">
                        <p>Укажите количество выданного материала</p>
                        {givenFlyers.map((ft) => (
                            <div key={ft._id}>
                                <span>{ft.name}</span>
                                <Input
                                    onBlur={() => setGivenFlyersCount(givenFlyers)}
                                    type="number"
                                    min={0}
                                    value={givenFlyers.find((f) => f._id === ft._id)?.count}
                                    changeHandler={(e) =>
                                        setGivenFlyersHandler(+e.target.value, ft._id)
                                    }
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </Popup>
        );
    };

    const closeFnHandler = () => {
        localStorage.removeItem(ASSIGN_ROUTE_BET_NAME);
        setPopup(false)
    }
    return (
        <div className="map__route-block route-block dark-theme-bg1">
            {isPopup && (
                <AssignPromoter
                    city={city}
                    mailboxCount={mailboxCount}
                    routeLocks={locks}
                    closeFn={closeFnHandler}
                    assignFn={assignPromoterHandler}
                    withCard
                />
            )}
            {isLockingPopup.flag && <LockingRoutePopup isUnlock={isLockingPopup.isUnlock} />}
            {isEditPopup && <EditRoutePopup />}
            {isFinishRoutePopup && <CreateFinishRoutePopup cityId={data.city._id} routeId={data.id} closeFn={() => setFinishRoutePopup(false)} />}
            <div className="route-block__header">
                <div>Маршрут #{id}</div>
                <div onClick={closeFn}>X</div>
            </div>
            <div className="route-block__body">
                <div className="route-block__info">
                    <div className="route-block__col">
                        <div>Ящиков: {mailboxCount}</div>
                        <div>Подъездов: {porchCount}</div>
                    </div>
                    <div className="route-block__col">
                        <div>
                            Статус: <span style={{ color: statusColor }}>{getStatusName()}</span>
                        </div>
                        {!status && <div>Промоутер: {promoter.fullname}</div>}
                    </div>
                </div>
                <div className="route-block__manager">
                    {status < 0 && (
                        <>
                            <Button text="Назначить" onClick={() => setPopup(true)} />
                            <Button text="Закрыть вручную" onClick={() => setFinishRoutePopup(true)} />
                            <Button
                                text="Блокировать"
                                disabled={false}
                                onClick={() => setLockingPopup({ flag: true, isUnlock: false })}
                            />
                        </>
                    )}

                    {!status && (
                        <>
                            <Button
                                disabled={isBtnBlocked}
                                text="Отозвать"
                                onClick={revokeRouteHandler}
                            />
                            <Button text="Редактировать" onClick={() => setEditPopup(true)} />
                            <Link className="button" to={`../active_routes/${data._id}`}>
                                Просмотр
                            </Link>
                        </>
                    )}
                </div>
                {/* {hasLocks && (
                        <div className='route-block__locks'>
                            <h4>Блокировки маршрута</h4>
                            <div className='route-block__locks-content'>
                                <div>
                                    {lockItems.map(l => <div>
                                        <span>{l.flyer}:</span>
                                        <span>до {new Date(l.until).toLocaleString()}</span>
                                    </div>)}
                                </div>
                            <div>
                                <Button
                                        text="Разблокировать"
                                        onClick={() => setLockingPopup({ flag: true, isUnlock: true })}
                                    />
                            </div>
                            </div>
                        </div>
                    )} */}
                    <div className='route-block__history'>
                        <h4 onClick={toggleHistoryDetailsHandler}>История {isHistoryDetailsOpen ? '▲' : '▼'}</h4>
                        <div className={`route-block__history-content ${isHistoryDetailsOpen?'opened':''}`}>

                            {isLoading && <div>Загрузка..</div>}
                            {error && <div>{error}</div>}
                            {!!routeHistory && !routeHistory.length && <div>Данных пока нет</div>}

                            {!!routeHistory && !!routeHistory.length && <>
                                <div className="history-list__headers">
                                    <div>Начал</div>
                                    <div>Закончил</div>
                                    <div>Промоутер</div>
                                </div>
                                {!!routeHistory && !!routeHistory.length && <div className='history-list'>
                                {routeHistory.map(el => <Link to={`../finished_route/${el.id}`} key={el.id} className='history-list__item'>
                                    <div>{getLocalUTCDate(data.city.UTC, el.startedAt)}</div>
                                    <div>{getLocalUTCDate(data.city.UTC, el.finishedAt)}</div>
                                    <div>{el.promoter.fullname} (id{el.promoter.id})</div>
                                </Link>)}
                            </div>}
                            </>}
                        </div>
                    </div>
            </div>
        </div>
    );
};

export const AdvertMap = ({ routes, cities, flyers }) => {
    const [searchParams] = useSearchParams();
    const routeIdParam = searchParams.get('routeId');
    const thisRoute = routes.find((r) => r.id === +routeIdParam) || null;
    const dispatch = useDispatch();

    const [city, setCity] = useState(
        thisRoute
            ? cities.find((c) => c._id === thisRoute.city._id)?._id
            : getStorageData(cities, ADVERT_CITY_STORAGE_NAME),
    );
    const promoters = useSelector((state) => state.advert.promoters);
    const routeIdsWithFlyers = promoters.filter(p => p.currentRoute._id && p.city._id === city).map(p => {
        const createObj = (obj) => ({_id: obj._id, flyers: obj.flyers.map((f) => f._id)})
        return [createObj(p.currentRoute), ...p.routeQueue.map(r => createObj(r))];
    });
    const routeIdsFormatted = [];
    routeIdsWithFlyers.forEach(obj => obj.forEach(r => routeIdsFormatted.push(r)))
    const checkActiveRouteStatus = (_id) => {
        const thisFlrs = routeIdsFormatted.find((rObj) => rObj._id === _id)?.flyers;
        if (!thisFlrs) return false;
        return thisFlrs.some((f1) => flyer.some(f2 => f2 === f1));
    }

    const [flyer, setFlyer] = useState([getStorageData(flyers, ADVERT_FLYER_STORAGE_NAME)]);
    const [isMultiFlyerSelect, setIsMultiFlyerSelect] = useState(false);
    const [withCard, setWithCard] = useState(false);

    const setMultiFlyerHandler = (value) => {
        if (flyer.some(f => f === value)) {
            if (flyer.length < 2) return;
            setFlyer(prev => prev.filter(f => f !== value))
            return;
        }
        setFlyer(prev => [...prev, value])
    }
    useEffect(() => {
        setFlyer([flyer[0]]);
    }, [isMultiFlyerSelect])

    const setFlyerHandler = createHandlerWithStorage(setFlyer, ADVERT_FLYER_STORAGE_NAME);
    const setCityHandler = createHandlerWithStorage(setCity, ADVERT_CITY_STORAGE_NAME);

    const [visibleRouteIndexes, setVisibleRouteIndexes] = useState([-1, 0, 1]);
    const setVisibleRoutesHandler = (status) => {
        if (visibleRouteIndexes.some((r) => r === status)) {
            setVisibleRouteIndexes(visibleRouteIndexes.filter((r) => r !== status));
            return;
        }
        setVisibleRouteIndexes((prev) => [...prev, status]);
    };
    const displayedRoutes = [...routes].sort((a,b) => a.id - b.id)
        .map((r) => ({
            ...r,
            status: r.details.locks.some((l) => flyer.some(f => f === l.flyer)) ? 1 : checkActiveRouteStatus(r._id) ? 0 : -1,
        })).map(r => {
            if (!withCard || r.status === -1) return {...r, markCard: false}
            if (r.status === 1) {
                const thisFlyerCardState = r.details.markedCards?.find((c) => flyer.some(f => f === c.flyer));
                return {...r, markCard: thisFlyerCardState?.withCard || false}
            }
            const thisProm = promoters.find(p => [p.currentRoute, ...p.routeQueue].some(actR => actR._id === r._id));
            const thisAssignedRoute = thisProm ? [thisProm.currentRoute, ...thisProm.routeQueue].find(actR => actR._id === r._id) : null
            return {...r, markCard: thisAssignedRoute?.withCard || false}
        })
        .filter((r) => visibleRouteIndexes.some((r2) => r.status === r2 && r.city._id === city));

    const thisCityFirstRoute = routes.find((r) => r.city._id === city);
    const defaultCenter = thisCityFirstRoute && thisCityFirstRoute.coordinates[0];
    const [mapCenter, setMapCenter] = useState(
        thisRoute ? thisRoute.coordinates[0] : defaultCenter || [0, 0],
    );
    const [mapZoom, setMapZoom] = useState(thisRoute ? 16 : 9);
    const [routeInfoId, setRouteInfoId] = useState(thisRoute && thisRoute.id);

    const isIncluded = (status) => visibleRouteIndexes.some((r) => r === status);

    const showSelectedRouteHandler = (id, coords) => {
        setRouteInfoId(id);
        setMapCenter(coords);
        setMapZoom(16);
    };

    const routeListBody = (
        <div className="map-routes-list">
            {displayedRoutes.map((r) => (
                <div
                    key={r._id}
                    className="map-routes-list__item dark-theme-hover-bg1"
                    onClick={() => showSelectedRouteHandler(r.id, r.coordinates[0])}>
                    <div>
                        <div
                            style={{
                                backgroundColor: !r.status
                                    ? '#1e98ff'
                                    : r.status > 0
                                    ? '#1bad03'
                                    : '#ed4543',
                            }}></div>
                    </div>
                    <div>№{r.id}</div>
                    <div>{r.mailboxCount}ящ</div>
                    <div>{r.porchCount}п</div>
                </div>
            ))}
        </div>
    );

    return (
        <div className="advert__map">
            <YMaps query={{ apikey: MAP_API_KEY }}>
                <Map
                    width={'100%'}
                    height={'100%'}
                    style={{ position: 'relative', height: '100%' }}
                    state={{ center: mapCenter, zoom: mapZoom }}>
                    {displayedRoutes.map((r) => (
                        <PromRoute
                            key={r._id}
                            data={r}
                            setMapCenter={setMapCenter}
                            routeInfoId={routeInfoId}
                            setRouteInfoId={setRouteInfoId}
                            flyerTypes={flyer}
                            flyers={flyers}
                        />
                    ))}
                    <div className="map__manager">
                        <div className="map-city">
                            <Select
                                enums={cities}
                                value={city}
                                changeHandler={(e) => setCityHandler(e.target.value)}
                            />
                        </div>
                        <div className="map-flyer">
                            {!isMultiFlyerSelect
                            ? <select value={flyer[0]} onChange={(e) => setFlyerHandler([e.target.value])}>
                                {flyers.map(f => <option className='dark-theme-bg0' key={f._id} value={f._id}>{f.name}</option>)}
                            </select> 
                            : <select multiple value={flyer} onChange={(e) => setMultiFlyerHandler(e.target.value)}>
                                {flyers.map(f => <option className='dark-theme-bg0' style={{backgroundColor: flyer.some(f2 => f2 == f._id) ? '#534a4a':'inherit'}} key={f._id} value={f._id}>{f.name}</option>)}
                            </select>}
                        </div>
                        <div className="map-flyer-select-changer">
                            <Button
                                text={isMultiFlyerSelect ? 'Выбрать несколько' : 'Выбрать одну'}
                                onClick={() => setIsMultiFlyerSelect(prev => !prev)}
                            />
                        </div>
                        <div className="map-card-switcher">
                            <Button
                                text={withCard ? 'Визитки отмечены' : 'Отметить визитки'}
                                onClick={() => setWithCard(prev => !prev)}
                            />
                        </div>
                    </div>
                    <div className="map-filters">
                        <div
                            className={`map-filter red ${isIncluded(-1) ? 'active' : ''}`}
                            onClick={() => setVisibleRoutesHandler(-1)}>
                            <NotFinishedSvg width={32} height={32} />
                        </div>
                        <div
                            className={`map-filter blue ${isIncluded(0) ? 'active' : ''}`}
                            onClick={() => setVisibleRoutesHandler(0)}>
                            <InProccesSvg
                                fill={`${isIncluded(0) ? 'white' : 'black'}`}
                                width={32}
                                height={32}
                            />
                        </div>
                        <div
                            className={`map-filter green ${isIncluded(1) ? 'active' : ''}`}
                            onClick={() => setVisibleRoutesHandler(1)}>
                            <FinishedSvg
                                fill={`${isIncluded(1) ? 'white' : 'black'}`}
                                width={32}
                                height={32}
                            />
                        </div>
                    </div>
                    <WrapWindow
                        showScroll={true}
                        title="Список маршрутов"
                        body={routeListBody}
                        footer={<></>}
                    />
                </Map>
            </YMaps>
        </div>
    );
};
